import { ExerciseGameType } from '@/api/common';
import Exercise from '@/api/exercise';
import { isEmpty, isNil } from 'lodash';
import { ISentenceCheck } from './common';

export function convertExerciseToSentence(exercise: Exercise): ISentenceCheck {
  const { game_type } = exercise;

  if (
    game_type === ExerciseGameType.PRONUNCIATION ||
    game_type === ExerciseGameType.WORD_STRESS ||
    game_type === ExerciseGameType.SENTENCE_STRESS
  ) {
    const speakingContent = exercise.speaking_content;
    if (isNil(exercise.speaking_content)) {
      return {
        lessonId: exercise.parent_lesson.toString(),
        exerciseId: exercise.id.toString(),
        firstSentence: '',
        secondSentence: '',
        gameType: game_type,
        firstIPA: '',
        secondIPA: '',
        firstStatus: '',
        secondStatus: 'No Speaking Content',
        processing: '',
        contentCheck: '',
        audio: '',
        errorLog: ''
      };
    }

    const secondSentence = speakingContent.sentence;
    return {
      lessonId: exercise.parent_lesson.toString(),
      exerciseId: exercise.id.toString(),
      firstSentence: '',
      secondSentence,
      gameType: game_type,
      firstIPA: '',
      secondIPA: '',
      firstStatus: '',
      secondStatus: '',
      processing: '',
      contentCheck: '',
      audio: '',
      errorLog: ''
    };
  }

  if (
    game_type === ExerciseGameType.CONVERSATION ||
    game_type === ExerciseGameType.VIDEO_CONVERSATION
  ) {
    const speakingContent = exercise.speaking_content;
    const conversationContent = exercise.conversation_content;

    if (isNil(exercise.speaking_content)) {
      return {
        lessonId: exercise.parent_lesson.toString(),
        exerciseId: exercise.id.toString(),
        firstSentence: '',
        secondSentence: '',
        gameType: game_type,
        firstIPA: '',
        secondIPA: '',
        firstStatus: '',
        secondStatus: 'No Speaking Content',
        processing: '',
        contentCheck: '',
        audio: '',
        errorLog: ''
      };
    }

    const firstSentence = conversationContent
      ? conversationContent.sentence
      : '';

    const secondSentence = speakingContent.sentence;

    return {
      lessonId: exercise.parent_lesson.toString(),
      exerciseId: exercise.id.toString(),
      firstSentence,
      secondSentence,
      gameType: game_type,
      firstIPA: '',
      secondIPA: '',
      firstStatus: '',
      secondStatus: '',
      processing: '',
      contentCheck: '',
      audio: '',
      errorLog: ''
    };
  }

  if (
    game_type === ExerciseGameType.LISTEN_TEXT2AUDIO ||
    game_type === ExerciseGameType.LISTEN_AUDIO2TEXT
  ) {
    if (
      isNil(exercise.listening_content) ||
      isEmpty(exercise.listening_content.items)
    ) {
      return {
        lessonId: exercise.parent_lesson.toString(),
        exerciseId: exercise.id.toString(),
        firstSentence: '',
        secondSentence: '',
        gameType: game_type,
        firstIPA: '',
        secondIPA: '',
        firstStatus: 'No Listening Item',
        secondStatus: 'No Listening Item',
        processing: '',
        contentCheck: '',
        audio: '',
        errorLog: ''
      };
    }

    const listeningContent = exercise.listening_content;
    const firstListeningItem = listeningContent.items[0];
    const secondListeningItem = listeningContent.items[1];

    return {
      lessonId: exercise.parent_lesson.toString(),
      exerciseId: exercise.id.toString(),
      firstSentence: firstListeningItem.sentence,
      secondSentence: secondListeningItem.sentence,
      gameType: game_type,
      firstIPA: '',
      secondIPA: '',
      firstStatus: isEmpty(firstListeningItem.sentence) ? 'Empty Sentence' : '',
      secondStatus: isEmpty(secondListeningItem.sentence)
        ? 'Empty Sentence'
        : '',
      processing:
        isEmpty(firstListeningItem.sentence) ||
        isEmpty(secondListeningItem.sentence)
          ? ''
          : '',
      contentCheck: '',
      audio: '',
      errorLog: ''
    };
  }

  return null;
}
